import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getNextPaymentActionsState = createSelector(
    (store: IStore) => store.nextPaymentActions,
    store => store,
);
